// ============================================================
// src/components/Insurance.js
// ============================================================
import React from "react";
import { useHospital } from "../context/HospitalContext";

const DEFAULT_INSURERS = [
  "Star Health",
  "New India",
  "HDFC ERGO",
  "ICICI Lombard",
  "Bajaj Allianz",
  "Niva Bupa",
  "Aditya Birla",
];

export default function Insurance() {
  const { hospital } = useHospital();

  // ✅ All dynamic from hospital config
  const title =
    hospital.insuranceTitle || "We Accept All Major Insurance Plans";
  const desc =
    hospital.insuranceDesc ||
    "Cashless treatment available at our clinic. We're empanelled with leading health insurers.";
  const insurers =
    hospital.insurers && hospital.insurers.length > 0
      ? hospital.insurers
      : DEFAULT_INSURERS;

  return (
    <section className="insurance">
      <div className="insurance-inner">
        {/* ✅ Dynamic title + description */}
        <h3>{title}</h3>
        <p>{desc}</p>
        <div className="insurance-logos">
          {insurers.map((name) => (
            <div key={name} className="ins-logo">
              {name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
